<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <div style="margin-left: -2rem;margin-right: -2rem;">
<!--        year=={{year}} //  thai_student=={{thai_student}}-->
<!--        <b-breadcrumb :items="items_62" v-if="thai_student==1 && year==2562" />-->
<!--        <b-breadcrumb :items="items_63" v-if="thai_student==1 && year==2563" />-->
<!--        <b-breadcrumb :items="items_eng_62" v-if="thai_student==0 && year==2562" />-->
<!--        <b-breadcrumb :items="items_eng_63" v-if="thai_student==0 && year==2563" />-->

      </div>

      <!-- <create-bio></create-bio> -->
      <create-excelnotregis></create-excelnotregis>
    </div>
  </div>
</template>

<script>
import CreateExcelnotregis from "../../components/CreateExcelnotregis.vue";


export default {
  components: {
    CreateExcelnotregis,

  },
  name: "Excelnotregis",
  data() {
    return {
      items_62: [
        {
          text: "ออกจากระบบ",
          href: "#/Logout"
        },
        {
          text: "หน้าหลัก",
          href: "#/Main"
        },
        {
          text: "หนังสือยืนยันการขอรับปริญญาบัตร",
          href: "#"
        }
      ],
      items_63: [
        {
          text: "ออกจากระบบ",
          href: "#/Logout"
        },
        {
          text: "หน้าหลัก",
          href: "#/Main"
        },
        {
          text: "หนังสือยืนยันการขอรับปริญญาบัตร",
          href: "#"
        }
      ],
      items_eng_62: [
        {
          text: "Home",
          href: "#/Main"
        },
        {
          text: "Logout",
          href: "#/Logout"
        },
        {
          text: "Form for Receipt of Degree Certificate",
          href: "#"
        }
        ], items_eng_63: [
        {
          text: "Home",
          href: "#/Main"
        },
        {
          text: "Logout",
          href: "#/Logout"
        },
        {
          text: "Form for Receipt of Degree Certificate",
          href: "#"
        }],
     /* items: [
        {
          text: "หน้าหลัก",
          href: "#/Dashboard"
        },
        {
          text: "ออกจากระบบ",
          href: "#/Logout"
        },
        {
          text: "หนังสือยืนยันการขอรับปริญญาบัตร",
          href: "#"
        }
      ],
      items_eng: [
        {
          text: "Home",
          href: "#/Dashboard"
        },
        {
          text: "Logout",
          href: "#/Logout"
        },
        {
          text: "Form for Receipt of Degree Certificate",
          href: "#"
        }
      ],*/
      categorey: []
    };
  },
  methods: {},
  mounted() {},
  created() {
    // this.thai_student = this.$store.state.user.thaistudent;
    // this.year= this.$store.state.user.year;
  }
};
</script>
<style></style>
